import { render } from "./CompatibilityGate.vue?vue&type=template&id=7ac2318b"
import script from "./CompatibilityGate.vue?vue&type=script&lang=js"
export * from "./CompatibilityGate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__